var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddGuest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 34,
    height: 34,
    rx: 3.5,
    fill: "white",
    stroke: "#DDDDDD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10238_42881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9944 11.5788L17.0881 11.5842C16.8414 11.5842 16.6375 11.788 16.6322 12.0401L16.6321 16.5882L11.9983 16.5882C11.7514 16.5882 11.5476 16.792 11.5424 17.0441V17.9559C11.5423 18.2027 11.7461 18.4065 11.9983 18.4118L16.6215 18.4118L16.6322 22.9599C16.6322 23.2067 16.836 23.4105 17.0881 23.4158L17.9999 23.4158C18.2466 23.4158 18.4504 23.212 18.4558 22.9599L18.4557 18.4118L23.0039 18.4118C23.2506 18.4118 23.4544 18.208 23.4598 17.9559L23.4598 17.0442C23.4598 16.7974 23.256 16.5936 23.0039 16.5883L18.4504 16.5936L18.4504 12.0455C18.4503 11.788 18.2465 11.5842 17.9944 11.5788Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10238_42881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.33333,
    height: 9.33333,
    fill: "white",
    transform: "translate(10.9011 17.5) rotate(-45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddGuest);
export default __webpack_public_path__ + "static/media/addGuest.4b778adfbccaad672cec550ebd559dbc.svg";
export { ForwardRef as ReactComponent };